export const API_PROJECT_DESCRIPTION = 'api/project-description';
export const API_BUSINESS_AS_USUAL_FOR_FEEDSTOCK = 'api/business-as-usual-for-feedstock';
export const API_BIOCHAR_AND_WATER_SUPPLY_EQUIPMENT = 'api/supply-equipment';
export const API_FEEDSTOCK_SOURCE = 'api/feedstock-source';
export const API_BURN_SUPERVISOR = 'api/burn-supervisor';
export const API_PROJECT_STAKEHOLDERS = 'api/project-stakeholders';
export const API_ENTITY_DETAILS = 'api/entity-details';